import styled, { createGlobalStyle } from 'styled-components';
export var VenmoGlobalStyles = createGlobalStyle(["#venmo-desktop-web-backdrop{z-index:100;}"]);
export var VenmoButton = styled.button.withConfig({
  componentId: "sc-ig8jfx-0"
})(["display:inline-block;background-repeat:no-repeat;background-position:50% 50%;background-color:#429bd9;background-image:url('", "site/logos/Venmo_White_Logo.svg');border:none;border-radius:4px;padding:0px;box-sizing:border-box;height:100%;width:100%;max-width:750px;cursor:pointer;"], function (props) {
  return props.cdnUrl;
});
export var VenmoButtonContainer = styled.div.withConfig({
  componentId: "sc-ig8jfx-1"
})(["text-align:center;height:100%;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Venmo/styled.js
// module id = 1741
// module chunks = 11